<template>
    <div class="headerCompany">
      <h1>{{ $t('mindset.label.listMindsets.title') }}</h1>

      <v-data-table
        :search="searchTerm"
        v-model="selected"
        :headers="headers"
        :items="mindsets"
        item-key="tituloBienvenida"
        show-select
        @item-selected="handleItemSelection"
        :no-data-text="$t('chart.label.notData') || 'No hay datos disponibles'"
        :footer-props="{ 'items-per-page-text': $t('label.rowsPerPage.title') }"
      >
        <!-- Sección superior de la tabla -->
        <template v-slot:top>
          <div style="margin-bottom: 50px">
            <div class="row justify-space-between mx-auto">
              <v-text-field
                :label="$t('label.search.title')"
                :placeholder="$t('label.search.text')"
                append-icon="mdi-magnify"
                dense
                outlined
                class="col-md-5"
                @input="search"
              ></v-text-field>
  
              <div class="btn">
                <addMindset/>
              </div>
            </div>
          </div>
        </template>

        <template v-slot:[`item.tituloBienvenida`]="{ item }">
          <span class="custom-font">{{ item.tituloBienvenida }}</span>
        </template>
  
        <template v-slot:[`item.action`]="{ item }">
          <!-- Botón de acción para abrir el diálogo de detalles  -->
          <v-icon
            color="primary"
            size="x-large"
          ></v-icon>
          
          <div class="actions">
            <detailsMindset
                :mindsetProps="item"
                style="margin-left:1vh"
              ><v-btn
                icon    
                x-large
                dark
                text
                >             
                <v-icon class="mt-2" color="primary">mdi-border-color</v-icon>
            </v-btn>
            </detailsMindset>

            <v-btn
              class="btnDetails"
              icon    
              x-large
              dark
              text
              @click = "deleteMindset(item.idImagenEmpresa)"
              style="background-color: transparent; margin-left:1vh"
            >
              <v-icon color="primary">mdi-delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </div>
  </template>
  
  <script>
  import detailsMindset from "@/views/mindset/pages/detail_mindset/detail_mindset_page.vue";
  import addMindset from "@/views/mindset/pages/add_mindset/add_mindset_page.vue";
  import { mapActions, mapGetters } from "vuex";
  import i18n from '@/plugins/i18n';
  import Swal from "sweetalert2";
  
  import {
    MINDSET_M,
    GET_MINDSETS,
    ACTION_GET_LIST_MINDSETS,
    ACTION_DELETE_MINDSET,
    ACTION_PUT_UPDATE_MINDSET,
  } from "@/views/mindset/store/types/types.js";
  
  export default {
    name: "listMindsetComponent",
    components: {
      addMindset,
      detailsMindset
    },
  
    data() {
      return {
        searchTerm: "",
        selected: [],
      };
    },
  
    async mounted() {
      await this.getActionMindsets();
    },
    watch: {
      mindsets: {
        handler(newMindsets) {
          if (newMindsets && newMindsets.length > 0) {
            // Filtrar y seleccionar las filas que tienen estado en true
            this.selected = newMindsets.filter(item => item.estado === true);
          }
        },
        immediate: true, // Ejecutar inmediatamente cuando se cargue el componente
        deep: true // Detectar cambios profundos en los objetos
      }
    },
    methods: {
  
      ...mapActions({
        getActionMindsets: `${MINDSET_M}${ACTION_GET_LIST_MINDSETS}`,
        deleteActionMindset: `${MINDSET_M}${ACTION_DELETE_MINDSET}`,
        updateActionMindset: `${MINDSET_M}${ACTION_PUT_UPDATE_MINDSET}`,
      }),

      handleItemSelection({ item, value }) {
        item.estado = value;
        this.updateActionMindset(item);      
      },

      search() {
        // Actualiza el término de búsqueda
        this.searchTerm = event.target.value;
      },
  
      async deleteMindset(id) {
          const result = await Swal.fire({
            title: i18n.t('label.delete.title'),
            text: i18n.t('label.delete.text'),
            icon: "question",
            showCancelButton: true,
            confirmButtonText: i18n.t('button.delete.accept'),
            cancelButtonText: i18n.t('button.delete.cancel'),
            confirmButtonColor: "#6E17A5"
          });
  
          if (result.isConfirmed) {
            await this.deleteActionMindset(id);
            await this.getActionMindsets();
          } else {
            Swal.fire({
              position: 'top-end',
              icon: 'info',
              title: i18n.t('label.delete.cancel'),
              showConfirmButton: false,
              timer: 2500
            }); 
          }
      },
  
    },
  
    computed: {
  
      ...mapGetters({
        mindsets: [`${MINDSET_M}${GET_MINDSETS}`],
      }),
  
      headers() {
        return [
          {
            text: this.$t('mindset.label.table.title'),
            value: "tituloBienvenida",
            sortable: false,
            align: "center",
            class: "primary--text text-h1 text-md-h5 text-lg-h5 custom-header font-weight-medium text-subtitle-1",
          },
          {
            //text: "Acciones",
            value: "action",  // Cambiado de 'action' a 'actions'
            sortable: false,
            align: "center",
            //class: "primary--text custom-header mdi-pencil text-subtitle-1",
          },
        ];
      }, 
    },
    
  };
  </script>
  
  <style lang="css" scoped>
  
    .headerCompany h1 {
      margin-bottom: 30px;
    }
  
    .headerCompany {
      display: flex;
      gap: 40px;
      flex-direction: column;
      margin-top: 20px;
      margin-left: 20px;
    }
  
    .actions v-icon {
      font-size: 24px;
    }
    .custom-font {
      font-size: 20px;
    }
    /* Define los estilos (Tipo de letra) para las etiquetas h1,h2,h3,h4,h5,h6   */
    body {
      font-family: "Nunito Sans", sans-serif;
    }
    
    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: "Amsi Pro", sans-serif;
      color: #2d0049;
      font-weight: normal;
    }
  /* Estilos para el botón de eliminar */
    .btnDetails .v-icon {
      color: #6E17A5;
      margin-bottom: 19px;
    }
  
    /**estilo de los iconos */
    .actions{
      display:flex;
         
    }

    /* .marginIcon{
      margin-top: 12;
    } */
  
    img{
      width: 3rem;
      height: 3rem;
    }
  
    @media screen and (max-width: 414px) {
          
          h1{
              font-size:3vh;
              margin-left:2vh
          }
          .custom-font{
            font-size: 13px;
          }
          img{
            margin-top: 18px;
            margin-bottom: auto;
            width: 3rem;
            height: 3rem;
          }
      }
  
      @media screen and (min-width: 414px) {
          
          h1{
              font-size:4vh;
              margin-left:2vh
          }
        
      }
   
      @media screen and (max-width: 280px) { 
  
          h1{
              font-size:3vh;
              margin-left:2vh
          }
          h2{
              font-size:2vh;
          }
          .custom-font{
            font-size: 13px
          }
          img{
            margin-top: 20px;
            margin-bottom: 10px;
            width: 3rem;
            height: 3rem;
          }
      } 
  
  </style>
  